<template>
  <div>
    <wc-page-title title='Dashboard' :loading='isLoading'>
      <template v-slot:rightSide>
        <wc-toolbar-search v-model='search'></wc-toolbar-search>
      </template>
    </wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <inquiries-table :search='search' :inquiries='inquiries'></inquiries-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import inquiriesAPI from '../api/inquiries'
import InquiriesTable from '../components/InquiriesTable'
import _ from 'lodash'

export default {
  name: 'inquiries-dashboard',
  data: () => ({
    isLoading: true,
    search: '',
    inquiries: []
  }),
  computed: {
    moduleData () {
      return this.$store.state.icons.modules.inquiries
    },
    divisions () {
      return this.$store.state.misc.divisions
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.inquiries = _.orderBy(await inquiriesAPI.getOpenInquiries(), 'date_created')
      this.isLoading = false
    }
  },
  components: {
    'inquiries-table': InquiriesTable
  }
}
</script>
